module.exports = __webpack_public_path__ + "media/iggy.00fbcad0.wav";